module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8.cbc07259.png";